module.exports = __webpack_public_path__ + "media/images/city-8e928e752eaed529d4ac23a33336627f.jpg";